export default "__VITE_ASSET__SlciIYIJ__"